import React, { useState, useRef, useEffect } from 'react';
import { getProductTypeOptions } from '../utils/insuranceTypeUtils';

const ProductTypeSelect = ({ selectedProductTypes, setSelectedProductTypes, insuranceType }) => {
  const [showProductTypePopup, setShowProductTypePopup] = useState(false);
  const productTypeRef = useRef(null);
  const productTypeOptions = getProductTypeOptions(insuranceType);
  const isAllSelected =
    productTypeOptions.length > 0 &&
    productTypeOptions.every((productType) => selectedProductTypes.includes(productType));
  const selectAllCheckboxId = `product-type-select-all-${insuranceType}`;

  // Show/hide product type popup
  const toggleProductTypePopup = () => {
    setShowProductTypePopup(!showProductTypePopup);
  };
  
  // Handle product type selection
  const handleProductTypeSelect = (productType) => {
    setSelectedProductTypes(prev => {
      if (prev.includes(productType)) {
        return prev.filter(p => p !== productType);
      } else {
        return [...prev, productType];
      }
    });
  };

  const handleToggleSelectAll = () => {
    setSelectedProductTypes(isAllSelected ? [] : [...productTypeOptions]);
  };

  // Detect clicks outside the popup to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productTypeRef.current && !productTypeRef.current.contains(event.target)) {
        setShowProductTypePopup(false);
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="selection-option">
      <div 
        className="option-label"
        onClick={toggleProductTypePopup}
        style={{ cursor: 'pointer' }}
      >
        保険商品種類
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 3V14H11" stroke="#0073BC" strokeWidth="2"/>
          <rect x="5" y="1" width="8" height="9" fill="white" stroke="#0073BC" strokeWidth="2"/>
        </svg>
      </div>
      <div
        className="option-value"
        data-type="product"
        onClick={toggleProductTypePopup}
      >
        {selectedProductTypes.length === 0 ? (
          "指定なし"
        ) : (
          <div className="selected-companies-list">
            {selectedProductTypes.slice(0, 5).map((type, index) => (
              <div key={index} className="selected-company-item">{type}</div>
            ))}
            {selectedProductTypes.length > 5 && (
              <div className="selected-company-item remaining-count">
                他{selectedProductTypes.length - 5}件
              </div>
            )}
          </div>
        )}
      </div>

      {/* Product type popup */}
      {showProductTypePopup && (
        <div className={`popup-base product-type-popup ${showProductTypePopup ? 'show' : ''}`} ref={productTypeRef}>
          <div className="popup-header">
            <span>保険商品種類</span>
            <div className="popup-header-actions">
              <button 
                type="button"
                className="popup-complete-btn" 
                onClick={toggleProductTypePopup}
                aria-label="保険商品種類の選択を完了してポップアップを閉じる"
              >
                選択完了
              </button>
            </div>
          </div>
          <div className="popup-content insurance-checkbox-grid-2">
            {productTypeOptions.length === 0 ? (
              <div className="no-companies-message">
                <p>選択可能な商品種類がありません。</p>
              </div>
            ) : (
              <>
                <div className="company-checkbox-item select-all-inline">
                  <label className='checkbox-native-box'>
                    <input
                      className='checkbox-native'
                      type="checkbox"
                      id={selectAllCheckboxId}
                      checked={isAllSelected}
                      onChange={handleToggleSelectAll}
                    />
                  </label>
                  <label htmlFor={selectAllCheckboxId}>全て選択</label>
                </div>
                  {productTypeOptions.map((productType) => {
                    const checkboxId = `product-type-${insuranceType}-${productType.replace(/\s+/g, '-').toLowerCase()}`;
                    return (
                      <div key={productType} className="company-checkbox-item">
                        <label className='checkbox-native-box'>
                          <input
                            className='checkbox-native'
                            type="checkbox"
                            id={checkboxId}
                            checked={selectedProductTypes.includes(productType)}
                            onChange={() => handleProductTypeSelect(productType)}
                          />
                        </label>
                        <label htmlFor={checkboxId}>{productType}</label>
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductTypeSelect;
